const normalize = (name) => String(name || '').toLowerCase().trim();

export const isTanzaniaConstitutionType = (name) => {
    const n = normalize(name);
    return (
        n.includes('tume ya katiba') ||
        n === 'constitution of tanzania' ||
        n === 'tanzania constitution' ||
        n === 'katiba ya tanzania' ||
        (n.includes('tanzania') && (n.includes('constitution') || n.includes('process')))
    );
};

export const isJournalType = (name) => normalize(name).includes('journal');

export const isBookType = (name) => {
    const n = normalize(name);
    return n.includes('book') && !n.includes('journal');
};

export const isReportType = (name) => normalize(name).includes('report');

export const isRegionalCourtsType = (name) => normalize(name).includes('regional court');

export const isLocalCourtsType = (name) => {
    const n = normalize(name);
    if (n.includes('regional')) return false;
    return n.includes('local court') || n === 'case' || n === 'cases' || n.includes('case');
};

export const isCuttingType = (name) => normalize(name).includes('cutting');
export const isAudioType = (name) => normalize(name).includes('audio');
export const isVideoType = (name) => normalize(name).includes('video');

export const isArticleType = (name) => {
    const n = normalize(name);
    return n === 'article' || n === 'articles';
};

export const isDedicatedCatalogType = (name) =>
    isTanzaniaConstitutionType(name) ||
    isJournalType(name) ||
    isBookType(name) ||
    isReportType(name) ||
    isLocalCourtsType(name) ||
    isRegionalCourtsType(name) ||
    isCuttingType(name) ||
    isAudioType(name) ||
    isVideoType(name);

export const CATALOG_GROUPS = [
    {
        id: 'constitutions',
        label: 'Constitutions',
        hasMenuChildren: true,
        children: [
            { id: 'constitution-tz', label: 'Constitutions of Tanzania and Processes', match: isTanzaniaConstitutionType }
        ]
    },
    {
        id: 'books-journals',
        label: 'Books & Journals',
        hasMenuChildren: true,
        children: [
            { id: 'journals', label: 'Journals', match: isJournalType },
            { id: 'books', label: 'Books', match: isBookType }
        ]
    },
    {
        id: 'reports',
        label: 'Reports',
        hasMenuChildren: false,
        children: [{ id: 'reports', label: 'Reports', match: isReportType }]
    },
    {
        id: 'cases',
        label: 'Cases',
        hasMenuChildren: true,
        children: [
            { id: 'local-courts', label: 'Local Courts', match: isLocalCourtsType },
            { id: 'regional-courts', label: 'Regional Courts', match: isRegionalCourtsType }
        ]
    },
    {
        id: 'cuttings',
        label: 'Cuttings',
        hasMenuChildren: false,
        children: [{ id: 'cuttings', label: 'Cuttings', match: isCuttingType }]
    },
    {
        id: 'audiovisuals',
        label: 'Audiovisuals',
        hasMenuChildren: true,
        children: [
            { id: 'audios', label: 'Audios', match: isAudioType },
            { id: 'videos', label: 'Videos', match: isVideoType }
        ]
    },
    {
        id: 'others',
        label: 'Others',
        hasMenuChildren: false,
        includeUnmatched: true,
        children: [{ id: 'article', label: 'Article', match: isArticleType }]
    }
];

const typeIdsKey = (types) =>
    types
        .map((type) => type.id)
        .sort((a, b) => a - b)
        .join(',');

export const displayNameForType = (type) => {
    if (!type?.name) return '';
    for (const group of CATALOG_GROUPS) {
        const child = group.children.find((item) => item.match(type.name));
        if (child) return child.label;
    }
    return type.name;
};

export const resolveCatalogGroups = (materialTypes = []) => {
    const usedIds = new Set();

    const groups = CATALOG_GROUPS.map((group) => {
        const options = group.children.map((child) => {
            const types = (materialTypes || []).filter((type) => child.match(type.name));
            types.forEach((type) => usedIds.add(type.id));
            return {
                ...child,
                types,
                queryId: typeIdsKey(types)
            };
        }).filter((option) => option.types.length > 0);

        if (group.includeUnmatched) {
            (materialTypes || [])
                .filter((type) => !usedIds.has(type.id) && !isDedicatedCatalogType(type.name))
                .forEach((type) => {
                    usedIds.add(type.id);
                    options.push({
                        id: `other-${type.id}`,
                        label: type.name,
                        types: [type],
                        queryId: String(type.id)
                    });
                });
        }

        const allTypes = options.flatMap((option) => option.types);
        return {
            ...group,
            options,
            types: allTypes,
            queryId: typeIdsKey(allTypes),
            showSubFilter: group.hasMenuChildren || options.length > 1
        };
    }).filter((group) => group.types.length > 0);

    return groups;
};

export const findGroupForTypeId = (groups, typeId) => {
    const id = Number(typeId);
    return groups.find((group) => group.types.some((type) => type.id === id)) || null;
};

export const findOptionForTypeId = (group, typeId) => {
    const id = Number(typeId);
    return group?.options.find((option) => option.types.some((type) => type.id === id)) || null;
};
